import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TrajectoryModel } from 'src/app/models/Trajectory';
import { Procedure, ProcedureModel } from 'src/app/models/procedure';
import { PointsService } from 'src/app/services/points.service';
import { ProceduresService } from 'src/app/services/procedures.service';

@Component({
  selector: 'app-trajetcory-rvt-kmz',
  templateUrl: './trajetcory-rvt-kmz.component.html',
  styleUrls:  ['../../../app.component.scss'],
  standalone: false
})
export class TrajetcoryRvtKmzComponent implements OnInit {

  @Input() format: string;

  trajectory: TrajectoryModel = new TrajectoryModel();
  constructor(private bsModalRef : BsModalRef,private procedureService: ProceduresService,
    private pointController: PointsService) { }


  ngOnInit(): void {

  }



  trajectoryFile: File = null;





  getFileFormat(){
    return this.format? "."+this.format.toLowerCase(): "";
  }
  cancelImport(): void {
    this.bsModalRef.hide();
  }

  fileChange($event): void {
    this.trajectoryFile = $event.target.files[0];
  }



  startImport(): void {

    this.pointController.uploadTrajectory(this.trajectoryFile,this.format, this.trajectory,true) ;
    this.bsModalRef.hide();
  }

}
